module.exports = __webpack_public_path__ + "img/gift-01-c5.391e36f9.png";